import React, { useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { BarChart3, RefreshCw } from "lucide-react";
import SummaryWidgets from "./SummaryWidgets";
import SalesChart from "./SalesChart";
import ProfitComparisonChart from "./ProfitComparisonChart";
import TopSellingProducts from "./TopSellingProducts";
import LowStockList from "./LowStockList";
import SalesComparisonChart from "./SalesComparisonChart";
import DashboardFilters from "./DashboardFilters";
import HighProfitVsVolumeChart from "./HighProfitVsVolumeChart";
import "./Stats.css";

const localDate = date => date.toLocaleDateString("en-CA");

const DashboardPage = () => {
  const today = localDate(new Date());
  const [dateRange, setDateRange] = useState({ startDate: today, endDate: today });
  const [refreshKey, setRefreshKey] = useState(0);
  const [isFiltered, setIsFiltered] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDateChange = range => {
    setDateRange(range);
    setIsFiltered(true);
    setRefreshKey(value => value + 1);
  };

  const handlePageReload = () => {
    setLoading(true);
    setRefreshKey(value => value + 1);
    window.setTimeout(() => setLoading(false), 350);
  };

  return <main className="stats-dashboard container-fluid">
    <section className="stats-toolbar">
      <div className="stats-heading"><span><BarChart3 size={20}/></span><div><small>Form 9</small><h1>Business analytics</h1><p>Sales, profit, product performance, and inventory health.</p></div></div>
      <div className="stats-actions"><DashboardFilters onDateChange={handleDateChange}/><Button variant="outline-primary" onClick={handlePageReload} disabled={loading}>{loading ? <Spinner size="sm"/> : <RefreshCw size={16}/>} Refresh</Button></div>
    </section>

    <section className="stats-kpis"><SummaryWidgets key={`summary-${refreshKey}`} dateRange={dateRange} refreshKey={refreshKey}/></section>

    <div className="stats-section-title"><div><small>Performance</small><h2>Sales and profit trends</h2></div><span>{dateRange.startDate} — {dateRange.endDate}</span></div>
    <section className="stats-chart-grid">
      <div className="stats-panel stats-panel-wide"><SalesChart key={`sales-${refreshKey}`} dateRange={dateRange} refreshKey={refreshKey} isFiltered={isFiltered}/></div>
      <div className="stats-panel"><SalesComparisonChart key={`sales-comparison-${refreshKey}`} dateRange={dateRange} refreshKey={refreshKey}/></div>
      <div className="stats-panel"><ProfitComparisonChart key={`profit-${refreshKey}`} dateRange={dateRange} refreshKey={refreshKey}/></div>
      <div className="stats-panel stats-panel-wide"><HighProfitVsVolumeChart key={`profit-volume-${refreshKey}`} dateRange={dateRange} refreshKey={refreshKey}/></div>
    </section>

    <div className="stats-section-title"><div><small>Products and stock</small><h2>Inventory attention</h2></div></div>
    <section className="stats-bottom-grid">
      <div className="stats-panel"><TopSellingProducts key={`top-${refreshKey}`} dateRange={dateRange} refreshKey={refreshKey}/></div>
      <div className="stats-panel"><LowStockList key={`stock-${refreshKey}`} refreshKey={refreshKey}/></div>
    </section>
  </main>;
};

export default DashboardPage;
